export default __webpack_public_path__ + "static/fall8-cc1ecee8c40aaf5f003a810ce642b8a8.webp";